var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6908 10.4692C8.82504 10.5309 8.97628 10.5449 9.1196 10.5091C9.26292 10.4733 9.38977 10.3898 9.47925 10.2722L9.71 9.97C9.83109 9.80854 9.98811 9.6775 10.1686 9.58724C10.3491 9.49699 10.5482 9.45 10.75 9.45H12.7C13.0448 9.45 13.3754 9.58696 13.6192 9.83076C13.863 10.0746 14 10.4052 14 10.75V12.7C14 13.0448 13.863 13.3754 13.6192 13.6192C13.3754 13.863 13.0448 14 12.7 14C9.59697 14 6.62103 12.7673 4.42685 10.5731C2.23268 8.37897 1 5.40303 1 2.3C1 1.95522 1.13696 1.62456 1.38076 1.38076C1.62456 1.13696 1.95522 1 2.3 1H4.25C4.59478 1 4.92544 1.13696 5.16924 1.38076C5.41304 1.62456 5.55 1.95522 5.55 2.3V4.25C5.55 4.45182 5.50301 4.65087 5.41276 4.83138C5.3225 5.01189 5.19145 5.16891 5.03 5.29L4.7258 5.51815C4.60647 5.60927 4.52236 5.73888 4.48776 5.88498C4.45317 6.03107 4.47021 6.18464 4.536 6.3196C5.42434 8.12391 6.88538 9.58312 8.6908 10.4692Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.067f19198fef2ea02726b97bcf1561bf.svg";
export { ForwardRef as ReactComponent };